export const getAccessToken = () => {
  return localStorage.getItem('ancho:accessToken')
}

export const setAccessToken = (token: string) => {
  localStorage.setItem('ancho:accessToken', token)
}

// how far in advance of its expiration an access token gets refreshed
const ACCESS_TOKEN_REFRESH_THRESHOLD_SECONDS = 10

export const shouldRefresh = (accessToken: string): boolean => {
  const refreshAt =
    parseAccessTokenExpiration(accessToken) -
    ACCESS_TOKEN_REFRESH_THRESHOLD_SECONDS
  const now = Math.floor(new Date().getTime() / 1000)

  return refreshAt < now
}

const parseAccessTokenExpiration = (accessToken: string): number => {
  return JSON.parse(base64Decode(accessToken.split('.')[1])).exp
}

const base64Decode = (s: string): string => {
  const binaryString = atob(s)

  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  return new TextDecoder().decode(bytes)
}
